
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, FreeMode } from 'swiper/modules';

export default function initItemCards() {
    // Default Swipers
    const defaultContainers = document.querySelectorAll('.item-cards:not(.item-cards--manual):not(.item-cards-grid) .swiper');

    defaultContainers.forEach(container => {
        new Swiper(container, {
            modules: [Navigation, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 24,
            navigation: {
                nextEl: container.parentElement.querySelector('.swiper-button-next'),
                prevEl: container.parentElement.querySelector('.swiper-button-prev'),
            },
            pagination: {
                el: container.parentElement.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });

    // Manual Marquee Swiper
    const manualContainers = document.querySelectorAll('.item-cards--manual:not(.item-cards-grid) .swiper');

    manualContainers.forEach(container => {
        const wrapper = container.querySelector('.swiper-wrapper');
        const slides = wrapper.querySelectorAll('.swiper-slide');

        if (slides.length > 0 && slides.length < 20) {
            const clonesNeeded = Math.ceil(20 / slides.length) - 1;
            for (let i = 0; i < clonesNeeded; i++) {
                slides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });
            }
        }

        new Swiper(container, {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 16,
            loop: true,
            loopAdditionalSlides: 10,
            speed: 12000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
        });
    });
}
